<template>
    <div class="component power-hours-day-graph">
        <div class="chart-container" :id="'chart-container-historic-tasks'" style="position: relative; height: 350px; width:" v-loading="loading">
            <canvas :id="'daygraph'+day"></canvas>
        </div>
    </div>
</template>

<script>
import { dataConvertDict } from '../../chart/ChartData.js'
import Chart from 'chart.js'

export default {
    props: ['day'],
    data () {
        return {
            loaded: true,
            chart: {},
            loading: true
        }
    },
    components: {
    },
    methods: {
        drawChart () {
            this.loading = true
            var ctx = document.getElementById('daygraph' + this.day).getContext('2d')
            let data = dataConvertDict['powerhoursweekdaygraph'](this.$store.state.performance.powerHoursGraphData, this.day)
            let chartData = data[0]
            let options = data[1]
            if (Object.keys(this.chart).length > 0) {
                this.chart.destroy()
            }
            this.chart = new Chart(ctx, { type: 'bar', data: chartData, options: options })
            this.loading = false
        }
    },
    created () {
        this.$store.dispatch('general/getUsers').then(response => {
            // this.drawChart()
            this.loaded = true
        })
    }
}
</script>
